import { useTranslations } from '@vocab/react';
import { Button, IconPersonVerified } from 'braid-design-system';
import type { FC } from 'react';

import translations from './.vocab';

interface UpgradeReferencesButtonProps {
  onClick: () => void;
}

export const UpgradeReferencesButton: FC<UpgradeReferencesButtonProps> = ({
  onClick,
}) => {
  const { t } = useTranslations(translations);

  return (
    <Button
      tone="neutral"
      variant="soft"
      size="small"
      icon={<IconPersonVerified />}
      onClick={(e) => {
        e.stopPropagation();
        onClick();
      }}
    >
      {t('Upgrade references')}
    </Button>
  );
};
